import { data } from '../../svg/EnergySavingsLeaf/data';
import { makeIcon } from '../makeIcon';

export const EnergySavingsLeaf = makeIcon(data, 'energy_savings_leaf', 'EnergySavingsLeaf');

export default EnergySavingsLeaf;
